import { handleActions } from 'redux-actions'
import { fromJS } from 'immutable'

import * as Actions from 'actions/saved_searches'
import * as AppActions from 'actions/app'

export const initialState = fromJS([])

export default handleActions({
  [Actions.fetchSavedSearchesTimelinesSuccess]: (state, { payload: timelines }) => fromJS(timelines),

  [AppActions.resetState]: () => initialState
}, initialState)
